import debounce from 'lodash/debounce';
import { updateSessionIdInCookie } from './tracking';

const UPDATE_SESSION_DEBOUNCE_TIME = 1000 * 60 * 5; // 5 minutes
export const DEFAULT_EVENTS = [
  'mousemove',
  'keydown',
  'wheel',
  'DOMMouseScroll',
  'mouseWheel',
  'mousedown',
  'touchstart',
  'touchmove',
  'MSPointerDown',
  'MSPointerMove',
  'visibilitychange',
];

export const trackUserActivityEvents = () => {
  if (typeof window !== 'undefined') {
    DEFAULT_EVENTS.forEach(e => {
      window.addEventListener(e, trackEvent);
    });
  }
};

const trackEvent = debounce(() => {
  updateSessionIdInCookie();
}, UPDATE_SESSION_DEBOUNCE_TIME);
